import * as S from './UpdateBanner.styles';

type UpdateBannerProps = {
  onRefresh: () => void;
};

const UpdateBanner = function ({ onRefresh }: UpdateBannerProps): JSX.Element {
  return (
    <S.Banner>
      <S.Message>A new version is available</S.Message>
      <S.RefreshButton onClick={onRefresh}>Refresh</S.RefreshButton>
    </S.Banner>
  );
};

export default UpdateBanner;
